"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityDetailsModal = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var moment = require("moment");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var detailsActions = require("@caddigital/sok-reducers/lib/actions/activity/details");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var mapStateToProps = function (state) {
    return {
        details: state.activity.details
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    revert: function (activity) {
        return dispatch(detailsActions.revertRequest(activity));
    },
    close: function () { return dispatch(detailsActions.toggleModal(false)); },
    clear: function () { return dispatch(detailsActions.clear()); }
}); };
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ActivityDetails'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.details.modalIsOpen !== prevProps.details.modalIsOpen &&
            !this.props.details.modalIsOpen) {
            this.props.clear();
        }
    }
}), recompose_1.pure);
var ActivityInfo = function (props) {
    if (props.activity === null) {
        return null;
    }
    return (React.createElement("div", { className: 'activity-info' },
        React.createElement("div", null,
            React.createElement("label", null, (0, translation_1.getLocalization)("userfront/admin/activity/header/id")),
            React.createElement("div", null, props.activity.id)),
        React.createElement("div", null,
            React.createElement("label", null, (0, translation_1.getLocalization)("userfront/admin/activity/header/name")),
            React.createElement("div", null, (0, translation_1.getLocalization)(props.activity.name))),
        React.createElement("div", null,
            React.createElement("label", null, (0, translation_1.getLocalization)("userfront/admin/activity/header/timestamp")),
            React.createElement("div", null, moment(props.activity.timestamp).format('L HH:mm'))),
        React.createElement("div", null,
            React.createElement("label", null, (0, translation_1.getLocalization)("userfront/admin/activity/header/email")),
            React.createElement("div", null, props.activity.email)),
        React.createElement("div", null,
            React.createElement("label", null, (0, translation_1.getLocalization)("userfront/admin/activity/header/project")),
            React.createElement("div", null, props.activity.project !== null ? props.activity.project : '-'))));
};
var activityDetailLabels = {
    101: 'admin/activity/details/files',
    102: 'admin/activity/details/files',
    103: 'admin/activity/details/files',
    104: 'admin/activity/details/files',
    105: 'admin/activity/details/files',
    106: 'admin/activity/details/files',
    107: 'admin/activity/details/files',
    111: 'admin/activity/details/createdUser',
    114: 'admin/activity/details/invitedUser',
    156: 'admin/activity/details/copiedFrom',
    158: 'admin/activity/details/updatedUser',
    159: 'admin/activity/details/updatedUser'
};
var ActivityDetails = function (props) {
    var _a, _b;
    var activity = props.activity, details = props.details;
    var metadata = (_a = activity === null || activity === void 0 ? void 0 : activity.metadata) !== null && _a !== void 0 ? _a : {};
    var hasMetadata = Object.keys(metadata).length > 0;
    var hasDetails = details.length > 0;
    if (!activity || (!hasMetadata && !hasDetails)) {
        return null;
    }
    var activityType = activity.activityType;
    var label = (0, translation_1.getLocalization)((_b = activityDetailLabels[activityType]) !== null && _b !== void 0 ? _b : String());
    if (hasMetadata) {
        return (React.createElement("div", { className: 'activity-details' },
            React.createElement("label", null, label),
            React.createElement("ul", null, Object.entries(metadata).map(function (_a, index) {
                var key = _a[0], value = _a[1];
                return (React.createElement("li", { key: index },
                    React.createElement("strong", null,
                        key,
                        ":"),
                    "\u00A0",
                    value));
            }))));
    }
    switch (activityType) {
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107: {
            return (React.createElement("div", { className: 'activity-details' },
                React.createElement("label", null, label),
                React.createElement("div", { className: 'file-list' },
                    React.createElement("ul", null, details.reduce(function (acc, x) {
                        if (x.type === 'FILE_ACTIVITY') {
                            acc.push(React.createElement("li", { key: "activity-".concat(x.id) }, x.fileName));
                        }
                        return acc;
                    }, [])))));
        }
        case 111:
        case 114:
        case 158:
        case 159: {
            var first = details[0];
            if (first.type !== 'USER_ACTIVITY' || !first.targetUser) {
                return null;
            }
            return (React.createElement("div", { className: 'activity-details' },
                React.createElement("label", null, label),
                React.createElement("div", null, first.targetUser)));
        }
        case 156: {
            var first = details[0];
            if (first.type !== 'PROJECT_ACTIVITY' || !first.copiedFrom) {
                return null;
            }
            return (React.createElement("div", { className: 'activity-details' },
                React.createElement("label", null, label),
                React.createElement("div", null,
                    first.copiedFrom,
                    " (ID: ",
                    first.copiedFromId,
                    ")")));
        }
        default:
            return null;
    }
};
var Revert = function (props) {
    if (props.details.activity && props.details.activity.activityType === 103) {
        var activity_1 = props.details.activity;
        return (React.createElement(sok_ui_1.Button, { color: 'green', onClick: function () { return props.revert(activity_1); }, disabled: props.details.revertStatus === 'FETCHING', text: (0, translation_1.getLocalization)('admin/activity/details/revert') }));
    }
    return null;
};
exports.ActivityDetailsModal = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.details.modalIsOpen, className: 'admin-activity-details-model' },
    React.createElement(sok_ui_1.Header, { onClose: function () { return props.close(); } }, (0, translation_1.getLocalization)('admin/activity/activityDetails')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.details.revertStatus },
            (0, translation_1.getLocalization)('admin/activity/activityDetails/revert/reverting'),
            (0, translation_1.getLocalization)('admin/activity/activityDetails/revert/success'),
            (0, translation_1.getLocalization)('admin/activity/activityDetails/revert/failed')),
        props.details.status === 'FETCHING' && (React.createElement("div", { className: 'center' },
            React.createElement(sok_ui_1.LoadingSpinner, null))),
        props.details.status === 'FAILED' && (React.createElement("div", { className: 'center' },
            React.createElement(GenericErrorMessage_1.default, null))),
        props.details.status === 'FETCHED' && (React.createElement(React.Fragment, null,
            React.createElement(ActivityInfo, { key: 'info', activity: props.details.activity }),
            React.createElement(ActivityDetails, { key: 'details', activity: props.details.activity, details: props.details.details })))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(Revert, { revert: props.revert, details: props.details }),
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.close(); }, text: (0, translation_1.getLocalization)('buttons/cancel') })))); });
